<section id="add-trail-form" class="p-2 text-center">

<button *ngIf="isAdmin" class="button-74" (click)="toggleAddTrail()">
    {{ showAddTrail ? 'Zapri' : 'Dodaj progo' }}</button>
<div *ngIf="showAddTrail" class="container text-start">
    <h2>Dodaj smučarsko progo</h2>
    <form [formGroup]="skiTrailForm" (ngSubmit)="addSkiTrail()">
      <div class="mb-3">
        <label for="name" class="form-label">Ime proge</label>
        <input id="name" type="text" class="form-control" formControlName="name">
      </div>
  
      <div class="mb-3">
        <label for="length" class="form-label">Dolžina (m)</label>
        <input id="length" type="number" class="form-control" formControlName="length">
      </div>
  
      <div class="mb-3">
        <label for="difficulty" class="form-label">Zahtevnost</label>
        <select id="difficulty" class="form-select" formControlName="difficulty">
          <option value="Lažja">Lažja</option>
          <option value="Srednje zahtevna">Srednje zahtevna</option>
          <option value="Zahtevna">Zahtevna</option>
        </select>
      </div>
  
      <div class="mb-3">
        <label for="description" class="form-label">Opis proge</label>
        <textarea id="description" class="form-control" formControlName="description"></textarea>
      </div>
  
      <!--<div class="mb-3">
        <label for="imageUrl" class="form-label">Image URL</label>
        <input id="imageUrl" type="text" class="form-control" formControlName="imageUrl">
      </div>-->
  
      <div class="mb-3">
        <label for="elevation" class="form-label">Vzpon (m)</label>
        <input id="elevation" type="number" class="form-control" formControlName="elevation">
      </div>
  
      <div class="mb-3 form-check">
        <input id="available" type="checkbox" class="form-check-input" formControlName="available">
        <label for="available" class="form-check-label">V obratovanju</label>
      </div>
  
      <div class="mb-3 form-check">
        <input id="classic" type="checkbox" class="form-check-input" formControlName="classic">
        <label for="classic" class="form-check-label">Klasična tehnika</label>
      </div>
  
      <div class="mb-3 form-check">
        <input id="skating" type="checkbox" class="form-check-input" formControlName="skating">
        <label for="skating" class="form-check-label">Drsalna tehnika</label>
      </div>
  
      <div class="mb-3">
        <label for="condition" class="form-label">Razmere proge</label>
        <input id="condition" type="text" class="form-control" formControlName="condition">
      </div>
  
      <button type="submit" class="button-74">Dodaj progo</button>
    </form>
  </div>
</section>

<section id="trails" class="mt-5">
  <div class="container">
    <div class="row">
      <div class="mb-4" *ngFor="let trail of skiTrails">
        <div class="trail-card card shadow-sm"
             (click)="toggleExpandedTrail(trail.id)"
             [ngClass]="{
               'available-full': trail.available,
               'available-border': !trail.available,
               'available-glow': trail.available,
               'not-available-full': !trail.available,
               'not-available-glow': !trail.available
             }">
          <div class="card-body d-flex justify-content-between align-items-center flex-wrap">
            <div class="d-flex align-items-center flex-wrap gap-3">
              <p class="card-title mb-0"><strong>{{ trail.name }}</strong></p>
              <p class="card-text mb-0">
                <fa-icon [icon]="faRuler"></fa-icon> {{ trail.length }} m
                <fa-icon class="ms-2" [icon]="faMountain"></fa-icon> {{ trail.elevation }} m
              </p>
            </div>

            <div class="d-flex align-items-center mt-md-0 me-5">
              <button class="btn me-2 skrij"
                      (click)="expandedTrailId = expandedTrailId === trail.id ? null : trail.id"
                      [attr.data-bs-toggle]="'collapse'"
                      [attr.data-bs-target]="'#trail-details-' + trail.id">
                <fa-icon class="fa-lg" [icon]="faCircleInfo"></fa-icon>
              </button>
              <button *ngIf="isAdmin" class="btn btn-sm btn-success me-2"
                      (click)="toggleSkiTrailAvailability(trail.id)">
                {{ trail.available ? 'Označi kot nedelujoče' : 'Označi kot delujoče' }}
              </button>
              <button *ngIf="isAdmin" class="btn btn-sm btn-danger"
                      (click)="deleteSkiTrail(trail.id)">
                <fa-icon class="fa-lg mb-0" [icon]="faTrash"></fa-icon>
              </button>
            </div>

            <div class="collapse w-100 mt-3"
                 [id]="'trail-details-' + trail.id"
                 [ngClass]="{'show': expandedTrailId === trail.id}">
              <p>
                <strong>Težavnost:</strong>
                <span [ngClass]="{
                  'text-success': trail.difficulty === 'Lažja',
                  'text-warning': trail.difficulty === 'Srednje zahtevna',
                  'text-danger': trail.difficulty === 'Zahtevna'
                }">
                  {{ trail.difficulty }}
                </span>
              </p>
              <p><strong>Opis:</strong> {{ trail.description }}</p>
              <p><strong>Stanje:</strong> {{ trail.condition }}</p>
              <p><strong>Klasično:</strong> {{ trail.classic ? 'Da' : 'Ne' }} |
                 <strong>Drsalno:</strong> {{ trail.skating ? 'Da' : 'Ne' }}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>


<div class="container mt-5 mb-5">
    <div class="row">
        <!-- First Map -->
        <div class="col-12 col-sm-6 mb-4">
            <iframe src="https://www.outdooractive.com/en/embed/284002619/iframe?mw=false&s=m" style="width: 100%; height: 517px; border: 0; "></iframe>
        </div>
        <!-- Second Map -->
        <div class="col-12 col-sm-6 mb-4">
            <iframe src="https://www.outdooractive.com/en/embed/284003108/iframe?mw=false&s=m" style="width: 100%; height: 517px; border: 0;" ></iframe>
        </div>
    </div>
</div>

<section id="parking" class="container">
  <h2 class="mb-4">PARKIRIŠČA</h2>

  <!-- Image section -->
  <div class="row mb-5">
    <div class="col-md-6">
      <img src="assets/images/organisations/sports/zemljevid.jpg" alt="Parking" class="img-fluid mb-3" style="border-radius: 10px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);">
    </div>

    <!-- Parking info section -->
    <div class="col-md-6">
      <h4>PARKIRIŠČA:</h4>
      <ul>
        <li>Označena na zemljevidu</li>
        <li>Pomožno parkirišče pri PGD Hotedršica (nasproti vstopa na krajši 2km krog)</li>
        <li>Pri gostilni Turk (nasproti vstopa na daljši 5km krog)</li>
        <li>Pri Stari šoli (Hotedršica 64, 1372 Hotedršica), cca 200m oddaljeno od vstopa na 5km krog</li>
        <li>Pomožno parkirišče pri POŠ Hotedršica, cca 300m oddaljeno od vstopa na 2km krog</li>
      </ul>
      <p><strong>POMEMBNO:</strong> (PROSIMO DA NE PARKIRATE AVTOMOBILOV V OBMOČJU GASILSKEGA DOMA, ZARADI MOŽNOSTI INTERVENCIJ IN IZSTOPA GASILSKEGA KAMIONA IN KOMBIJA)</p>
    </div>
  </div>

  <!-- SPLOŠNE INFORMACIJE Section with 2 columns -->
  <h4>SPLOŠNE INFORMACIJE:</h4>
  <div class="row mb-4">
    <!-- Left Column with Data -->
    <div class="col-md-6">
      <ul>
        <li>Teče se v smeri urinega kazalca (za lažje orientiranje so proge opremljene s puščicami)</li>
        <li>Na vstopu na 2km krog (nasproti gasilskega doma je postavljen zemljevid z opisom prog)</li>
        <li>Uporaba prog je brezplačna, veseli smo pa vsakega prispevka (škatla s prispevkom je nameščena ob zemljevidu na vstopu na 2km krog), denar je namenjen vzdrževanju prog, servisiranju snežnega teptalca in nakupu goriva</li>
        <li>Po progi se ne hodi in sprehaja kužkov, Hotedršica je zelo lepa v kolikor en teče in drugi ne, okolica ponuja fantastične sprehajalne poti</li>
      </ul>
      <p>Za vzdrževanje prog skrbita Igor Leskovec in Marko Moroz.</p>
        <!-- Contact Information Section -->
      <h4>Vse ostale informacije na voljo:</h4>
      <ul>
        <li>Jernej Šemrov 041/555-122</li>
        <li>Igor Leskovec 031/246-161</li>
      </ul>
    </div>
    
    <!-- Right Column with Image -->
    <div class="col-md-6">
      <img src="assets/images/organisations/sports/sd3.jpg" alt="Trail Maintenance" class="img-fluid mb-3" style="border-radius: 10px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);">
    </div>
  </div>

  <!-- History Section with 2 Columns -->
  <h4>Zgodovina Tekaških Prog:</h4>
  <div class="row mb-4">
    <!-- Left Column with History Text -->
    <div class="col-md-6">
      <p>Tekaške proge v Hotedršici imajo dolgo zgodovino in so poznane daleč naokoli. Ni slučajno, da je pobuda za organizacijo in izvedbo prvega tekmovanja lovcev lovskih družin v teku na smučeh v Sloveniji prišla prav iz Hotedršice pod okriljem LD Hotedršica. Prvo tekmovanje je bilo organizirano dne 27.1.1980 z imenom »Tek po Lovskih smučinah«. To ime je nosilo prvih sedem tekov do leta 1986. Leta 1987, ko je bil na sporedu osmi tek, se je ta preimenoval v »Lovske smučine za memorial Rada Pehačka«, dolgoletnega predsednika častnega odbora lovskih tekov.</p>
      <p>Zaradi milih zim skoraj brez snega, je bil leta 1992 organiziran jubilejni deseti tek, ter hkrati tudi zadnji tek v izvedbi LD Hotedršica. Leta 1998 je bil pod okriljem Športnega društva Hotedršica izpeljan »Božični tek na smučeh«. Zaradi pomanjkanja snega so bili naslednji teki izvedeni šele v letu 2004 in letu 2005, preimenovan v »Tek po Hotenjskih smučinah«, kasneje še v letu 2015 in letu 2018. Proge različnih dolžin, so bile trasirane po travnikih in poljih na južnem delu vasi Hotedršice.</p>
    </div>
    
    <!-- Right Column with 2 Images in a column -->
    <div class="col-md-6">
      <div class="row">
        <div class="col-12 mb-3">
          <img src="assets/images/organisations/sports/sd1.jpg" alt="First Race" class="img-fluid" style="border-radius: 10px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);">
        </div>
      </div>
    </div>
  </div>


</section>

